import { useState } from "react";
import { useI18n } from "../i18n";

/* Logos dos clientes — o arquivo fica em public/assets/logo/clientes/.
   Se a imagem não existir, o nome da empresa aparece no lugar. */
const CLIENTES = [
  { nome: "Petrobras", img: "/assets/logo/clientes/petrobras.png", url: "https://petrobras.com.br/" },
  { nome: "BMC Hyundai", img: "/assets/logo/clientes/bmc.png", url: "https://bmchyundai.com.br/" },
  { nome: "Varos", img: "/assets/logo/clientes/varos.png", url: "https://varos.com.br/" },
];

function LogoCliente({ nome, img, url }: (typeof CLIENTES)[number]) {
  const [falhou, setFalhou] = useState(false);
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener"
      aria-label={nome}
      className="flex h-12 w-36 shrink-0 items-center justify-center transition-opacity duration-300 hover:opacity-100"
    >
      {falhou ? (
        <span className="font-display text-sm font-medium tracking-tight text-subtle">
          {nome}
        </span>
      ) : (
        <img
          src={img}
          alt={nome}
          onError={() => setFalhou(true)}
          className="max-h-8 max-w-32 w-auto object-contain opacity-55 transition-all duration-300 [filter:grayscale(1)_contrast(0.85)] hover:opacity-90 hover:[filter:grayscale(0.3)]"
        />
      )}
    </a>
  );
}

/** Faixa deslizante com as empresas de onde vem a experiência —
    emoldurada por hairlines, no ritmo editorial do site. */
export function LogoMarquee() {
  const { t } = useI18n();
  return (
    <section aria-label={t("faixa.titulo")} className="relative border-y border-line bg-surface py-8">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-5 px-6 sm:flex-row sm:gap-10">
        <p className="shrink-0 font-mono text-[11px] tracking-[0.18em] text-subtle uppercase sm:max-w-44 sm:text-left">
          {t("faixa.titulo")}
        </p>
        <div
          className="w-full overflow-hidden"
          style={{
            maskImage:
              "linear-gradient(to right, transparent, black 14%, black 86%, transparent)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent, black 14%, black 86%, transparent)",
          }}
        >
          <div className="animate-marquee flex w-max gap-10 pr-10 hover:[animation-play-state:paused]">
            {[0, 1].map((copia) => (
              <div key={copia} className="flex gap-10" aria-hidden={copia === 1}>
                {CLIENTES.map((c) => (
                  <LogoCliente key={`${copia}-${c.nome}`} {...c} />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
